import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pending');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pending',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pending/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.pending-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px 16px;
  background: var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

.pending-panel {
  width: min(560px, 100%);
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  padding: 30px;
  box-shadow: var(--design-shadow-strong);
}

.eyebrow {
  margin: 0 0 8px;
  color: var(--design-brown);
  font-size: 13px;
  font-weight: 800;
}

h1 {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 800;
}

.pending-copy {
  margin: 0;
  color: var(--design-text-secondary);
  font-size: 14px;
  line-height: 1.7;
}

.pending-actions {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pending-actions a {
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 10px 13px;
  color: var(--design-accent);
  background: #ffffff;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}`],
})
export class PagePendingComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status && this.approvalStatus() === 'approved' && this.activeStatus() === 'active') {
            this.service.href('/main');
            return;
        }
        await this.service.render();
    }

    public userName(): string {
        return this.service.auth.session?.name || this.service.auth.session?.username || '가입 신청자';
    }

    public approvalStatus(): string {
        let session = this.service.auth.session || {};
        if (session.approvalStatus || session.approval_status) {
            return session.approvalStatus || session.approval_status;
        }
        if (session.status === 'rejected') return 'rejected';
        if (session.status === 'pending') return 'pending';
        return 'approved';
    }

    public activeStatus(): string {
        let session = this.service.auth.session || {};
        if (session.activeStatus) return session.activeStatus;
        if (session.isActive === false || session.is_active === false || session.status === 'inactive') return 'inactive';
        return 'active';
    }

    public statusEyebrow(): string {
        if (this.approvalStatus() === 'pending') return '회원가입 승인대기';
        if (this.approvalStatus() === 'rejected') return '회원가입 반려';
        if (this.activeStatus() === 'inactive') return '계정 비활성';
        return '계정 상태 안내';
    }

    public statusTitle(): string {
        if (this.approvalStatus() === 'pending') return '관리자 승인 후 이용할 수 있습니다';
        if (this.approvalStatus() === 'rejected') return '가입 신청이 반려되었습니다';
        if (this.activeStatus() === 'inactive') return '계정이 비활성화되었습니다';
        return '현재 계정으로 이용할 수 없습니다';
    }

    public statusCopy(): string {
        let name = this.userName();
        if (this.approvalStatus() === 'pending') {
            return `${name}님의 가입 승인은 대기 중입니다. 승인 후에도 역할과 자료 관리 권한은 관리자가 별도로 지정합니다.`;
        }
        if (this.approvalStatus() === 'rejected') {
            return `${name}님의 가입 신청은 반려 상태입니다. 재검토가 필요하면 관리자에게 문의해주세요.`;
        }
        if (this.activeStatus() === 'inactive') {
            return `${name}님의 가입 승인은 유지되지만 계정이 비활성 상태여서 주요 기능을 사용할 수 없습니다.`;
        }
        return '가입 승인과 계정 활성 상태가 모두 확인되어야 내부 기능을 사용할 수 있습니다.';
    }

    public showMainLink(): boolean {
        return !this.service.auth.status;
    }
}

export default PagePendingComponent;